import type { AccessPolicy } from "../guards/access-policy";
import { decideAccess } from "../guards/access-policy";
import { paths } from "../paths";
import type { Session } from "../session/session";

export interface NavItem {
  readonly to: string;
  readonly label: string;
  /** Omit for items everyone may see. Items the user can't open are hidden, not disabled. */
  readonly policy?: AccessPolicy;
}

/**
 * Main navigation (WEB-007). Only features that exist appear here — planned features are
 * never listed as links. Each batch adds its own entries with a policy.
 */
export const NAV_ITEMS: readonly NavItem[] = [
  { to: paths.home, label: "Home" },
  {
    to: paths.organizationAdmin,
    label: "Organization",
    policy: { permissions: ["org:read"] },
  },
  {
    to: paths.patients,
    label: "Patients",
    policy: { permissions: ["patient:read"] },
  },
  {
    to: paths.datasets,
    label: "Datasets",
    policy: { permissions: ["dataset:read"] },
  },
  {
    to: paths.aiModels,
    label: "AI models",
    policy: { permissions: ["ai:model_manage"] },
  },
  {
    to: paths.platformAdmin,
    label: "Platform",
    policy: { permissions: ["system:configure"] },
  },
  // Marketing-facing, visible to everyone (including signed-out visitors) -- no policy.
  { to: paths.secondOpinions, label: "Second opinions" },
  { to: paths.doctorNetwork, label: "Doctor network" },
  { to: paths.meetingsTrips, label: "Meetings & trips" },
];

export function visibleNavItems(
  session: Session,
  items: readonly NavItem[] = NAV_ITEMS,
): NavItem[] {
  return items.filter(
    (item) => !item.policy || decideAccess(session, item.policy).outcome === "allowed",
  );
}
